import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";

const FaqCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [question, setQuestion] = useState("");
	const [answer, setAnswer] = useState("");
	const [questions, setQuestiosn] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة سؤال جديد",
				breadcrumb: "الأسئلة الشائعة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	const pushToQuestions = e => {
		e.preventDefault();
		if (question === "" || answer === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { question, answer };
		questions.push(data);
		setQuestiosn(questions);
		setQuestion("");
		setAnswer("");
	};

	const handleDeleteQuestion = (event, question) => {
		event.preventDefault();
		const arr = questions.filter(function (item) {
			return item.question !== question.question;
		});
		setQuestiosn(arr);
	};

	const handleSubmit = e => {
		e.preventDefault();
		setLoading(true);
		const data = {
			title: title,
			questions: questions,
		};
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/posts`,
				{
					category_id: 8,
					admin_id: auth.data.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/faq/index");
				toast.success("تم اضافة السؤال بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-12">
						<div className="form-item">
							<label htmlFor="title">العنوان</label>
							<input
								type="text"
								id="title"
								required
								onChange={e => setTitle(e.target.value)}
							/>
						</div>
						<hr />
						<div className="form-item">
							<label htmlFor="question">السؤال</label>
							<input
								type="text"
								id="question"
								value={question}
								onChange={e => setQuestion(e.target.value)}
							/>
						</div>
						<div className="form-item">
							<label htmlFor="answer">الاجابة</label>
							<textarea
								id="answer"
								cols="30"
								rows="2"
								value={answer}
								onChange={e => setAnswer(e.target.value)}
							></textarea>
						</div>
						<div className="form-item">
							<ul className="list-unstyled pointList">
								{questions.map(item => (
									<li key={item.question}>
										<button onClick={e => handleDeleteQuestion(e, item)}>
											<i className="fas fa-trash"></i>
										</button>
										{item.question}
									</li>
								))}
							</ul>
						</div>
						<div className="form-item">
							<ul className="list-inline">
								<li className="list-inline-item">
									<button
										className="bt bt-success"
										style={{ marginLeft: "20px" }}
										onClick={pushToQuestions}
									>
										اضافة السؤال
									</button>
								</li>
								<li className="list-inline-item">
									<button className="bt bt-success">ارسال</button>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default FaqCreate;
